import ActionTypes from '../constants/ActionTypes';
import { api } from '../api/index';

export const fetchCategory = id => {
  return async dispatch => {
    try {
      const { data: category } = await api.get(`category/${id}`);
      return dispatch({
        type: ActionTypes.FETCH_CATEGORY_SUCCESS,
        payload: category
      });
    } catch (e) {
      return dispatch({
        type: ActionTypes.FETCH_CATEGORY_ERROR,
        payload: { id }
      });
    }
  };
};

export const fetchCategoryByKey = key => {
  return async dispatch => {
    try {
      const { data: category } = await api.get(`category/key/${key}`);
      return dispatch({
        type: ActionTypes.FETCH_CATEGORY_SUCCESS,
        payload: category
      });
    } catch (e) {
      return dispatch({
        type: ActionTypes.FETCH_CATEGORY_ERROR,
        payload: { key }
      });
    }
  };
};
